import React from 'react'
import { Form, Row, Col, Card } from 'react-bootstrap'

const ArticleReview = ({ review, inputData, sendinputdata, sendBooleanValueChangeDone }) => {
  const handleChange = e => {
    const { name, value } = e.target
    // Determine the correct value to set
    let newValue
    if (name === 'articleReviewRating') {
      const parsedValue = parseFloat(value)
      if (isNaN(parsedValue) || parsedValue < 1 || parsedValue > 5) {
        newValue = ''
      } else {
        newValue = parsedValue
      }
    } else {
      newValue = value
    }

    // Update the reviews within inputData
    const updatedReviews = {
      ...inputData.yousayArticleReviews,
      [name]: newValue,
    }

    // Create a new inputData object with the updated reviews
    const updatedInputData = {
      ...inputData,
      yousayArticleReviews: updatedReviews,
    }

    // Send the updated input data
    sendinputdata(updatedInputData)
    sendBooleanValueChangeDone('yousayArticleReviews', true)
  }

  const stopwheelAction = event => {
    event.target.blur()
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <Card className='mb-3 mt-3'>
      <Card.Body>
        <Form>
          <Form.Label style={{ color: 'black' }}>ArticleReview</Form.Label>
          <Row>
            <Col>
              <Form.Group controlId='articleReviewTitle_En'>
                <Form.Label style={{ color: 'black' }}>Title_En</Form.Label>
                <Form.Control
                  type='text'
                  name='articleReviewTitle_En'
                  value={review.articleReviewTitle_En}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId='articleReviewTitle_Te'>
                <Form.Label style={{ color: 'black' }}>Title_Te</Form.Label>
                <Form.Control
                  type='text'
                  name='articleReviewTitle_Te'
                  value={review.articleReviewTitle_Te}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId='articleReviewDescription_En'>
                <Form.Label style={{ color: 'black' }}>Description_En</Form.Label>
                <Form.Control
                  as='textarea'
                  name='articleReviewDescription_En'
                  value={review.articleReviewDescription_En}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId='articleReviewDescription_Te'>
                <Form.Label style={{ color: 'black' }}>Description_Te</Form.Label>
                <Form.Control
                  as='textarea'
                  name='articleReviewDescription_Te'
                  value={review.articleReviewDescription_Te}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId='articleReviewURL_En'>
                <Form.Label style={{ color: 'black' }}>URL_En</Form.Label>
                <Form.Control
                  type='text'
                  name='articleReviewURL_En'
                  value={review.articleReviewURL_En}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId='articleReviewURL_Te'>
                <Form.Label style={{ color: 'black' }}>URL_Te</Form.Label>
                <Form.Control
                  type='text'
                  name='articleReviewURL_Te'
                  value={review.articleReviewURL_Te}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId='articleReviewRating'>
            <Form.Label style={{ color: 'black' }}>Rating</Form.Label>
            <Form.Control
              type='number'
              name='articleReviewRating'
              value={review.articleReviewRating}
              onChange={handleChange}
              onWheel={event => stopwheelAction(event)}
            />
          </Form.Group>
          {/* <Button variant='primary' onClick={handleSave}>
              Save
            </Button>
            <Button variant='secondary' onClick={handleCancel} className='ml-2'>
              Cancel
            </Button> */}
        </Form>
      </Card.Body>
    </Card>
  )
}

export default ArticleReview
